<template>
  <v-layout class="main-wrapper" column>
    <v-container class="pb-2">
      <div class="d-flex align-center">
        <v-img :src="require('@/assets/logo.png')" max-width="10rem" contain />

        <v-spacer />

        <v-btn icon @click="signOut()">
          <v-icon> mdi-logout </v-icon>
        </v-btn>
      </div>
    </v-container>

    <router-view />
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Main",

  data() {
    return {
      drawer: true,
    };
  },

  computed: {
    ...mapGetters({
      _user: "user",
    }),

    _title() {
      return process.env.VUE_APP_PROJECT_NAME;
    },

    _routes() {
      return [
        {
          icon: "fas fa-home",
          label: "Início",
          path: "/home",
        },
        {
          icon: "fas fa-home",
          label: "Início",
          path: "/home",
        },
      ];
    },
  },

  methods: {
    handleDrawer() {
      this.drawer = !this.drawer;
    },

    signOut() {
      this.$root.$emit("sign-out");
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
